
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class FranchiseePaymentsDialog extends Serenity.EntityDialog<FranchiseePaymentsRow, any> {
        protected getFormKey() { return FranchiseePaymentsForm.formKey; }
        protected getIdProperty() { return FranchiseePaymentsRow.idProperty; }
        protected getLocalTextPrefix() { return FranchiseePaymentsRow.localTextPrefix; }
        protected getNameProperty() { return FranchiseePaymentsRow.nameProperty; }
        protected getService() { return FranchiseePaymentsService.baseUrl; }
        protected getDeletePermission() { return FranchiseePaymentsRow.deletePermission; }
        protected getInsertPermission() { return FranchiseePaymentsRow.insertPermission; }
        protected getUpdatePermission() { return FranchiseePaymentsRow.updatePermission; }

        protected form = new FranchiseePaymentsForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();
            //debugger;
            buttons.splice(3, 3);
           

            return buttons;
        }
    }
}